import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import EventForm from '../components/forms/EventForm/EventForm';
import './CreateEventPage.css';

/**
 * CreateEventPage - Standalone page wrapper for EventForm component
 * 
 * This page provides the routing context and navigation logic
 * while delegating all form logic to the EventForm component.
 */
function CreateEventPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { eventId } = useParams();

  const isEditMode = Boolean(eventId);

  // Build prefill from location state
  const prefill = {
    selectedDate: location.state?.selectedDate,
    defaultEventType: location.state?.defaultEventType,
    endeavorId: location.state?.endeavorId
  };

  // Handle cancel - navigate back
  const handleCancel = () => {
    if (location.state?.returnTo) {
      navigate(location.state.returnTo);
    } else {
      navigate('/calendar');
    }
  };

  // Handle success - navigate to event detail or returnTo
  const handleSuccess = (createdEvent) => {
    const normalizedId = createdEvent?._normalizedId || createdEvent?.eventId || createdEvent?.id;
    
    // Navigate after short delay to show success state
    setTimeout(() => {
      if (location.state?.returnTo) {
        navigate(location.state.returnTo);
      } else if (normalizedId) {
        navigate(`/event/${normalizedId}`);
      } else {
        navigate('/calendar');
      }
    }, 1500);
  };

  return (
    <div className="create-event-page">
      <div className="page-container">
        <div className="page-header">
          <h1>{isEditMode ? '✏️ Edit Event' : '✨ Create New Event'}</h1>
          <p className="page-subtitle">
            {isEditMode 
              ? 'Update the details of your event below' 
              : 'Add a new event to your calendar'}
          </p>
        </div>

        <div className="page-content">
          <EventForm
            prefill={prefill}
            compact={false}
            onCancel={handleCancel}
            onSuccess={handleSuccess}
            isEditMode={isEditMode}
            eventId={eventId}
          />
        </div>
      </div>
    </div>
  );
}

export default CreateEventPage;
